import { render, staticRenderFns } from "./paperCreate.vue?vue&type=template&id=7958b5cd&scoped=true&"
import script from "./paperCreate.vue?vue&type=script&lang=js&"
export * from "./paperCreate.vue?vue&type=script&lang=js&"
import style0 from "./paperCreate.vue?vue&type=style&index=0&id=7958b5cd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7958b5cd",
  null
  
)

export default component.exports